/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListBanksResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'Bank',
        },
      },
    },
  }],
} as const;
